import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useAppContext } from "../context/appContext";
import LoginLayout, { Input } from "../components/loginLayout";
import { API_URL } from "../apis/apiurl";
import PopupModel from "../components/model/popupModel";

const Login = () => {
  const { setPopupMessage } = useAppContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const loginUser = async ({ email, password }) => {
    const response = await fetch(`${API_URL}/graphql`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: `
          mutation LoginUser {
            loginUser(email: "${email}", password: "${password}") {
              email
              token
              role
              isVerified
            }
          }
        `,
      }),
    });
    const data = await response.json();
    if (data.errors) {
      const error = JSON.parse(data.errors[0].message);
      setPopupMessage(error?.message);
      throw new Error(error?.message);
    }
    return data.data.loginUser;
  };

  const { mutate, isPending, error } = useMutation({
    mutationFn: loginUser,
  });

  const isAdminRole = (role = "") => {
    const normalizedRole = role.toLowerCase();
    return (
      normalizedRole === "admin" ||
      normalizedRole === "administrator" ||
      normalizedRole === "administer"
    );
  };

  const handleRedirect = (userData) => {
    if (!userData) return;

    if (isAdminRole(userData.role) && !userData.isVerified) {
      setPopupMessage("Please verify your email before logging in.");
      return;
    }

    setIsRedirecting(true);

    const payload = encodeURIComponent(JSON.stringify(userData));
    const storageType = rememberMe ? "localStorage" : "sessionStorage";

    if (userData.role === "admin") {
      window.location.href = `https://admin.maximalsecurityservices.com/?storageType=${storageType}&data=${payload}`;
    } else if (userData.role === "management") {
      window.location.href = `https://management.maximalsecurityservices.com/?storageType=${storageType}&data=${payload}`;
    } else if (userData.role === "client") {
      window.location.href = `https://client.maximalsecurityservices.com/?storageType=${storageType}&data=${payload}`;
    } else {
      setPopupMessage("Wrong credentials");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && password) {
      mutate(
        { email, password },
        { onSuccess: (userData) => handleRedirect(userData) }
      );
    }
  };

  return (
    <LoginLayout
      error={error?.message}
      loading={isPending || isRedirecting}
      onSubmit={handleSubmit}
      title='Login'
      subtitle='Glad you’re back!'
      actionText='Log In'
      links={{ register: "/role", forgot: "/resetpassword" }}
    >
      <PopupModel />
      <Input
        type='email'
        placeholder='E-mail'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Input
        type='password'
        placeholder='Password'
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <div className='flex items-center'>
        <input
          type='checkbox'
          id='remember-me'
          className='mr-2'
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
        />
        <label htmlFor='remember-me' className='text-sm'>
          Remember me
        </label>
      </div>
    </LoginLayout>
  );
};

export default Login;
